import { TOOLTIP_TEXTS } from "@/constants/tooltip-texts"

import type { GameStatsSortKey } from "./components/game-stats-card/game-stats-card"
import { SeriesKind } from "./day-series"
import {
  IconAirtime,
  IconReach,
  IconShareOfAirtime,
  IconShareOfReach,
} from "./components/stream-card-icons"

/** Figma 3375:83368 — per-metric accent, icon, and series kind */
export const STATS_TYPES: {
  id: string
  title: string
  tooltip: string
  accentColor: string
  Icon: typeof IconReach
  seriesKind: SeriesKind
}[] = [
  {
    id: "stream-1",
    title: "Reach",
    tooltip: TOOLTIP_TEXTS.streamStats.reach,
    accentColor: "#CFD604",
    Icon: IconReach,
    seriesKind: SeriesKind.Reach,
  },
  {
    id: "stream-2",
    title: "Share of Reach",
    tooltip: TOOLTIP_TEXTS.streamStats.shareOfReach,
    accentColor: "#8CC522",
    Icon: IconShareOfReach,
    seriesKind: SeriesKind.SharePercent,
  },
  {
    id: "stream-3",
    title: "Airtime",
    tooltip: TOOLTIP_TEXTS.streamStats.airtime,
    accentColor: "#C75CE7",
    Icon: IconAirtime,
    seriesKind: SeriesKind.AirtimeMinutes,
  },
  {
    id: "stream-4",
    title: "Share of Airtime",
    tooltip: TOOLTIP_TEXTS.streamStats.shareOfAirtime,
    accentColor: "#E75C9B",
    Icon: IconShareOfAirtime,
    seriesKind: SeriesKind.SharePercentAirtime,
  },
]

export const GAME_STATS_TYPES: {
  id: string
  title: string
  tooltip: string
  sort: GameStatsSortKey
}[] = [
  {
    id: "game-1",
    title: "Top Reach",
    tooltip: TOOLTIP_TEXTS.streamStats.topReach,
    sort: "-reach",
  },
  {
    id: "game-3",
    title: "Average Viewers",
    tooltip: TOOLTIP_TEXTS.streamStats.averageViewers,
    sort: "-averageView",
  },
  {
    id: "game-2",
    title: "Top Airtime",
    tooltip: TOOLTIP_TEXTS.streamStats.topAirtime,
    sort: "-airtime",
  },
  {
    id: "game-4",
    title: "Peak Viewers",
    tooltip: TOOLTIP_TEXTS.streamStats.peakViewers,
    sort: "-peakView",
  },
]
